import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { setWindowDtm } from '../../../utils/DTM';
import { sendValidateOtp, mergeMobileWithEmail } from '../../../actionCreators/auth';
import { validateSessionV2, setToastMessage } from '../../../actionCreators/common';
import './OtpVerification.scss';
import Counter from './Counter';
import LinkWithText from './LinkWithText';
import sessionStorageHelper from '../../../utils/sessionStorageHelper';
import config from '../../../config';
class OtpVerification extends React.PureComponent {
  constructor(props) {
    super(props);
    this.renderInput = this.renderInput.bind(this);
    this.showhideCounter = this.showhideCounter.bind(this);
    this.onSubmitClick = this.onSubmitClick.bind(this);
    this.onResendOtpClick = this.onResendOtpClick.bind(this);
    this.onSkipOtpClick = this.onSkipOtpClick.bind(this);
    this.otpKeyDown = this.otpKeyDown.bind(this);
    this.pasteOtp = this.pasteOtp.bind(this);
    this.inputRef = React.createRef();
    const { authConfig } = this.props;
    this.state = {
      count: authConfig.SKIP_BTN_TIMEOUT ? parseInt(authConfig.SKIP_BTN_TIMEOUT, 10) : 30,
      showCounter: !this.props.counterNotRequired,
      otpDigits: 4,
      otpValue: ['', '', '', ''],
      isCaptchaVerified: false,
      captchaResponse: null,
      isCaptchaMounted: false,
    };
  }

  componentDidMount() {
    // this.triggerAutofill();
    if (this.props.isCaptchaRequired) {
      this.renderCaptcha();
    }
    this.inputRef.current.addEventListener('paste', this.pasteOtp);
  }

  componentDidUpdate(prevProps) {
    const { dataLocale, offerFlow, otpVerifySuccess, oTPLoginSuccess } = this.props;
    const { OTP_SENT_MOBILE } = dataLocale;
    if (prevProps.oTPLoginSuccess !== oTPLoginSuccess) {
      setTimeout(() => {
        this.props.validateSession();
      }, 500);
      if (offerFlow && oTPLoginSuccess) {
        otpVerifySuccess();
      }
    }
    if (
      prevProps.oTPSent !== this.props.oTPSent &&
      this.props.oTPSent &&
      !this.props.oTPSent.error &&
      !this.props.oTPSent.result
    ) {
      this.props.setToastMessage({ message: OTP_SENT_MOBILE });
      this.showhideCounter();
    }
    if (
      prevProps.isCaptchaRequired !== this.props.isCaptchaRequired &&
      this.props.isCaptchaRequired
    ) {
      this.renderCaptcha();
    } else if (
      this.props.isCaptchaRequired &&
      prevProps.oTPSent !== this.props.oTPSent &&
      this.state.isCaptchaVerified
    ) {
      this.resetCaptcha();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('paste', this.pasteOtp);
    if (this.props.isCaptchaRequired && this.state.isCaptchaMounted) {
      this.resetCaptcha();
    }
  }

  onSubmitClick(ev) {
    const { currentPhoneCode, localeInfo } = this.props;
    ev.preventDefault();
    if (this.state.otpValue.join('').length < 4) return;
    const { sendValidateOtp, phoneNumber, isMobileEmailMergeRequired, mergeMobileWithEmail } =
      this.props;
    this.dtmVerifyOtp(this.props);
    const data = {
      username: phoneNumber,
      code: this.state.otpValue.join(''),
      type: 'VALIDATE_OTP',
      validBlock: 'mobile',
    };
    data.phoneCode = currentPhoneCode;
    // if (isMobileEmailMergeRequired) {
    //   mergeMobileWithEmail({
    //     telephone: phoneNumber,
    //     phoneCode: localeInfo?.phoneCode,
    //     code: this.state.otpValue.join(''),
    //   });
    // } else {
    sendValidateOtp(data);
    // }
    const lastInput = document.getElementById('3');
    if (lastInput) lastInput.blur();
  }

  onResendOtpClick() {
    const { sendValidateOtp, phoneNumber, staticDTM, currentPhoneCode } = this.props;
    const dtmData = staticDTM || {};
    const dtm = {
      linkName: `${dtmData.channel}|resend otp`,
      linkPageName: `${dtmData.channel}|enter personal details`,
      pageVersion: dtmData.pageVersion,
      event: 'generic-int-link',
    };
    setWindowDtm(dtm, true);
    const data = {
      data: { username: phoneNumber },
      type: 'SEND_OTP',
    };
    data.phoneCode = currentPhoneCode;
    data.occurence = 'Resend';
    data.captchaKey = this.state.captchaResponse;
    sendValidateOtp(data);
  }

  onSkipOtpClick() {
    const { staticDTM, offerFlow, history, redirectAfterLogin } = this.props;
    const data = staticDTM || {};
    const dtm = {
      linkName: `${data.channel}|skip otp`,
      linkPageName: `${data.channel}|enter personal details`,
      pageVersion: data.pageVersion,
      event: 'generic-int-link',
    };
    setWindowDtm(dtm, true);
    sessionStorageHelper.setItem('userPh', this.props.phoneNumber);
    if (redirectAfterLogin) redirectAfterLogin(true);
    if (offerFlow && history) {
      history.replace('/');
    }
  }

  onOtpChange(ev) {
    const next = ev.target.nextElementSibling;
    const previous = ev.target.previousElementSibling;
    if (this.which !== 8) {
      this.state.otpValue[parseInt(ev.target.id, 10)] = ev.target.value;
      this.setState(
        {
          otpValue: [].concat(this.state.otpValue),
        },
        () => {
          if (next) next.focus(); // setTimeout(() => next.focus(), 10);
        }
      );
    } else if (this.which === 8) {
      this.state.otpValue[parseInt(ev.target.id, 10)] = '';
      this.setState(
        {
          otpValue: [].concat(this.state.otpValue),
        },
        () => {
          if (next || previous) {
            if (this.which === 8) {
              if (previous) previous.focus(); // setTimeout(() => previous.focus(), 10);
            } else if (next) next.focus(); // setTimeout(() => next.focus(), 10);
          }
        }
      );
    }
  }

  findindex = str => {
    const num = /\d/;
    const nums = str.match(num);
    return str?.indexOf(nums);
  };

  pasteOtp(event) {
    let paste = (event.clipboardData || window.clipboardData).getData('text');
    const pasteNumber = this.findindex(paste);
    paste = paste.slice(pasteNumber, pasteNumber + 4);
    const tempValue = [...this.state.otpValue];
    for (let i = 0; i < 4; i++) {
      tempValue[i] = paste[i];
    }
    this.setState({ otpValue: tempValue });
    event.preventDefault();
  }

  // triggerAutofill = async () => {
  //     const ac = new AbortController();
  //     setTimeout(() => {
  //         ac.abort();
  //     }, 1 * 60 * 1000);

  //     if ('OTPCredential' in window) {
  //         try {
  //             if (navigator.credentials) {
  //                 try {
  //                     console.log('reaced');
  //                     await navigator.credentials
  //                         .get({ otp: { transport: ['sms'] }, signal: ac.signal })
  //                         .then((otp) => {
  //                             console.log(otp);
  //                             console.log(otp.code);
  //                             const tempValue = [...this.state.otpValue];
  //                             for (let i = 0; i < 4; i++) {
  //                                 tempValue[i] = otp.code[i];
  //                             }
  //                             this.setState({ otpValue: tempValue });
  //                             alert(otp.code);
  //                             setOtp(otp.code);
  //                         })
  //                         .catch((err) => {
  //                             alert('Catch Block', err);
  //                         });
  //                 } catch (e) {
  //                     return;
  //                 }
  //             }
  //         } catch (err) {
  //             alert('f');
  //         }
  //     }
  // }

  dtmVerifyOtp() {
    const { staticDTM } = this.props;
    const data = staticDTM || {};
    const dtm = {
      pageName: `${data.channel}|verify otp`,
      channel: data.channel,
      subSection1: `${data.channel}|verify otp`,
      subSection2: `${data.channel}|verify otp`,
      ctaName: 'login successful',
      event: 'generic-int-link',
    };
    setWindowDtm(dtm, true);
  }

  showhideCounter() {
    this.setState({ showCounter: !this.state.showCounter });
  }

  otpKeyDown(ev) {
    ev.persist();
    if (ev.which === 13) return;
    this.which = ev.which;
    if (ev.which !== 8) {
      if (this.state.otpValue[parseInt(ev.target.id, 10)]) {
        if (ev.target.id < 4) {
          if (parseInt(ev.target.id, 10) === 3) {
            this.state.otpValue[parseInt(ev.target.id, 10)] = String.fromCharCode(ev.keyCode);
          } else {
            this.state.otpValue[parseInt(ev.target.id, 10) + 1] = String.fromCharCode(ev.keyCode);
          }
        }
        const next = ev.target.nextElementSibling;
        const previous = ev.target.previousElementSibling;
        this.setState(
          {
            otpValue: [].concat(this.state.otpValue),
          },
          () => {
            if (next || previous) {
              if (ev.which === 8) {
                if (previous) setTimeout(() => previous.focus(), 10);
              } else if (next) setTimeout(() => next.focus(), 10);
            }
          }
        );
      }
    } else {
      const previous = ev.target.previousElementSibling;
      if (previous) setTimeout(() => previous.focus(), 10);
    }
  }

  verifyCaptchaCallback = response => {
    if (response.length !== 0) {
      this.setState({
        isCaptchaVerified: true,
        captchaResponse: response,
      });
    }
  };

  resetCaptcha = () => {
    window.grecaptcha.reset();
    this.setState({
      isCaptchaVerified: false,
    });
  };

  renderCaptcha = () => {
    window.grecaptcha.render('recaptcha', {
      sitekey: config.siteKey,
      theme: 'light',
      callback: this.verifyCaptchaCallback,
      'expired-callback': this.resetCaptcha,
    });
    this.setState({ isCaptchaMounted: true, isCaptchaVerified: false });
  };

  /* eslint jsx-a11y/no-autofocus: 0 */
  renderInput() {
    const inputBoxes = [];
    const { otpDigits } = this.state;
    for (let index = 0; index < otpDigits; index += 1) {
      inputBoxes.push(
        <input
          key={index}
          autoComplete="off"
          autoFocus={index === 0}
          className="mr-r15 otp-unit text-center"
          id={index}
          maxLength="1"
          type="tel"
          value={this.state.otpValue[index]}
          onChange={ev => this.onOtpChange(ev, index)}
          onKeyDown={this.otpKeyDown}
        />
      );
    }
    return inputBoxes;
  }

  render() {
    const {
      phoneNumber,
      showLoginScreen,
      oTPSent,
      loading,
      otpType,
      dataLocale,
      offerFlow,
      currentPhoneCode,
      isCaptchaRequired,
      redisCommonData,
    } = this.props;
    const { count, showCounter, otpValue } = this.state;
    const {
      CHANGE_NUMBER,
      EDIT,
      ENTER_4_DIGIT_OTP,
      RE_SEND_OTP,
      SKIP,
      VERIFY_PHONE_NUMBER,
      BY_PROCEEDING_YOU_AGREE_TO_OUR,
      TERMS_AND_CONDITIONS,
    } = dataLocale;
    const skipTimerOtpWithoutTimer =
      redisCommonData?.SKIP_TIMER_OTP_CHECKOUT &&
      JSON.parse(redisCommonData?.SKIP_TIMER_OTP_CHECKOUT);
    return (
      <form noValidate onSubmit={this.onSubmitClick}>
        <div className="otp-verification mr-20 overflow-hidden" style={{ letterSpacing: '1px' }}>
          <div className="">
            <span className="fsp16 text-cool_grey">{currentPhoneCode}</span>
            <span className="fsp16">
              &nbsp;
              {phoneNumber}
            </span>
            <span
              className="pull-right fw-400 text-topaz"
              onClick={() => showLoginScreen(phoneNumber)}
            >
              {offerFlow ? CHANGE_NUMBER : EDIT}
            </span>
            <span className="block text-center fsp14 text-cool_grey mr-t30 mr-b30 text-uppercase">
              {ENTER_4_DIGIT_OTP}
            </span>
          </div>
          <div className="material-group mr-b10 otp-container overflow-hidden display-flex justify-space-around fsp20 w-80 mr-0auto">
            <div
              ref={this.inputRef}
              className="inner display-flex justify-space-around"
              id="input-field"
            >
              {this.renderInput()}
            </div>
            {oTPSent.error && (otpType === 'VALIDATE_OTP' || otpType === 'MERGE_MOBILE') && (
              <span className="block mr-t5 text-center text-orange fsp10">
                {oTPSent.error.message}
              </span>
            )}
          </div>
        </div>
        <div className="mr-t10 mr-b10">
          {showCounter ? (
            <Counter
              counterValue={count}
              dataLocale={dataLocale}
              showhideCounter={this.showhideCounter}
            />
          ) : (
            <Fragment>
              <span
                key="resend"
                className={`text-center block text-topaz fsp14 text-uppercase ${
                  !this.state.isCaptchaVerified && isCaptchaRequired ? 'resend-disable-msite' : ''
                }`}
                onClick={this.onResendOtpClick}
              >
                {RE_SEND_OTP}
              </span>
              {!skipTimerOtpWithoutTimer && (
                <span
                  key="skip"
                  className={`text-center block text-underline mr-t20 ${
                    offerFlow ? 'display-none' : ''
                  }`}
                  onClick={this.onSkipOtpClick}
                >
                  {SKIP}
                </span>
              )}
            </Fragment>
          )}
          {skipTimerOtpWithoutTimer && (
            <span
              key="skip"
              className={`text-center block text-underline mr-t20 ${
                offerFlow ? 'display-none' : ''
              }`}
              onClick={this.onSkipOtpClick}
            >
              {SKIP}
            </span>
          )}
        </div>
        <div className="mr-l10">
          {this.props.isCaptchaRequired && <div id="recaptcha"></div>}
          {this.props.isCaptchaRequired && (
            <button
              key="verify"
              className={`text-center block text-topaz fsp12 text-uppercase mr-t5 verify-btn ${
                this.state.isCaptchaVerified ? 'isEnabled' : ''
              }`}
              disabled={!this.state.isCaptchaVerified && this.props.isCaptchaRequired}
              onClick={this.onResendOtpClick}
            >
              VERIFY
            </button>
          )}
        </div>

        <div className="mr-t40" style={{ marginTop: '60px' }}>
          <LinkWithText
            linkText={TERMS_AND_CONDITIONS}
            styleObj="text-cool_grey block mr-l20 mr-b10 fsp10 mr-b10"
            text={BY_PROCEEDING_YOU_AGREE_TO_OUR}
            url="/terms-conditions"
          />
          <div className="fsp16 pd-5 bg-color_white display-flex">
            <button
              className={`new-btn text-color_white mr-l10 mr-r10 fsp16 ${
                otpValue.join('').length === 4 ? 'bg-topaz' : 'bg-pale_grey'
              }`}
              type="submit"
            >
              {!loading && !this.props.oTPLoginSuccess ? (
                <span className="pd-t10 pd-b10 block text-uppercase">{VERIFY_PHONE_NUMBER}</span>
              ) : (
                <span className="pd-t10 pd-b10 block icon-spinner animate-spin"></span>
              )}
            </button>
          </div>
        </div>
      </form>
    );
  }
}

const mapStateToProps = state => ({
  loading: state.auth.loading,
  oTPSent: state.auth.oTPSent,
  otpType: state.auth.otpType,
  oTPLoginSuccess: state.auth.oTPLoginSuccess,
  dataLocale: state.locale,
  redisCommonData: state.common.redisCommonData,
  localeInfo: state.common.localeInfo,
  isCaptchaRequired: state.auth.isCaptchaRequired,
});

function mapDispatchToProps(dispatch) {
  return {
    sendValidateOtp: data => dispatch(sendValidateOtp(data)),
    validateSession: () => dispatch(validateSessionV2()),
    setToastMessage: message => dispatch(setToastMessage(message)),
    mergeMobileWithEmail: data => dispatch(mergeMobileWithEmail(data)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(OtpVerification);
